module.exports = __webpack_public_path__ + "static/img/Upmood_Website Asset_Analyze.5956e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/Upmood_Website Asset_Analyze.png
// module id = Jrpq
// module chunks = 3